document.addEventListener('DOMContentLoaded', () => {

  const carousels = document.querySelectorAll('.homepage-carousel');

  carousels.forEach((carousel) => {

    const track = carousel.querySelector('.homepage-carousel__slides');

    let slides = carousel.querySelectorAll('.homepage-carousel__slide');

    if (slides.length < 2) return;

    const duration =
      parseInt(carousel.dataset.duration, 10) * 1000 || 5000;

    /*
    =========================================
    Clone First + Last Slides
    =========================================
    */

    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);

    firstClone.classList.add('is-clone');
    lastClone.classList.add('is-clone');

    track.appendChild(firstClone);
    track.prepend(lastClone);

    slides = carousel.querySelectorAll('.homepage-carousel__slide');

    /*
    =========================================
    State
    =========================================
    */

    let currentIndex = 1;
    let autoPlay;

    /*
    =========================================
    Positioning
    =========================================
    */

    function updatePosition(animated = true) {

      if (!animated) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform 0.8s ease';
      }

      track.style.transform =
        `translateX(-${currentIndex * 100}%)`;
    }

    updatePosition(false);

    /*
    =========================================
    Autoplay
    =========================================
    */

    function startAutoplay() {

      autoPlay = setInterval(() => {

        currentIndex++;

        updatePosition(true);

      }, duration);
    }

    function stopAutoplay() {
      clearInterval(autoPlay);
    }

    startAutoplay();

    /*
    =========================================
    Infinite Loop Reset
    =========================================
    */

    track.addEventListener('transitionend', () => {

      if (currentIndex >= slides.length - 1) {

        track.style.transition = 'none';

        track.offsetHeight;

        currentIndex = 1;

        track.style.transform =
          `translateX(-${currentIndex * 100}%)`;

      }

      if (currentIndex <= 0) {

        track.style.transition = 'none';

        currentIndex = slides.length - 2;

        track.style.transform =
          `translateX(-${currentIndex * 100}%)`;

      }

    });

    /*
    =========================================
    Touch / Swipe
    =========================================
    */

    let startX = 0;
    let currentX = 0;
    let isDragging = false;

    carousel.addEventListener('touchstart', (e) => {

      stopAutoplay();

      startX = e.touches[0].clientX;
      isDragging = true;

    });

    carousel.addEventListener('touchmove', (e) => {

      if (!isDragging) return;

      currentX = e.touches[0].clientX;

    });

    carousel.addEventListener('touchend', () => {

      if (!isDragging) return;

      const diff = startX - currentX;

      if (Math.abs(diff) > 50) {

        if (diff > 0) {
          currentIndex++;
        } else {
          currentIndex--;
        }

        updatePosition(true);
      }

      isDragging = false;

      startAutoplay();

    });

  });

});